<template>
	<div :class="classes"><slot /></div>
</template>

<script>
export default {
	name: 'Corridor',
	props: {
		flex: String
	},
	computed: {
		classes() {
			return [
				'corridor',
				{ 'corridor--row': this.flex === 'row' },
				{ 'corridor--column': this.flex === 'column' }
			]
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/mq';

.corridor {
	$max-width: 800px;
	$pad: 1.5rem;

	width: 100%;
	height: 100%;
	padding: 0 $pad;

	&--row,
	&--column {
		display: flex;
		align-items: center;
	}
	&--column {
		flex-direction: column;
	}

	@media (min-width: $max-width) {
		margin: 0 auto;
		max-width: $max-width;
	}
}
</style>
